import { Dropdown } from '@cmsgov/ds-medicare-gov';
import React from 'react';
import cloneObject from '../functions/clone.object';
import the from '../objects/the';
import './css/hidden.error.message.css';

export default function DropDown(props) {
   const getErrorMessage = () => {
      if (!props.errorMessage)
         return null;
      return <>
         <div style={{
            color: the.color.darkRed,
            fontSize: 14,
         }}>{props.errorMessage}</div>
      </>;
   };
   
   const clonedProps = cloneObject(props);
   delete clonedProps.errorMessage;
   
   return <>
      <Dropdown {...clonedProps}/>
      {getErrorMessage()}
   </>;
}